import React from "react";
import getTagColor from "../get-tag-color";

const TaskProgress = ({ percent }) => {
  const containerStyle = {
    width: "100%",
    overflow: "hidden",
    position: "relative",
    height: "1.875em",
  };

  const progressStyle = {
    width: `${percent}%`,
    backgroundColor: getTagColor(percent),
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.75em",
    fontWeight: "600",
    color: "#fff",
    textAlign: "center",
    whiteSpace: "nowrap",
    zIndex: 2,
  };

  const linesStyle = {
    background: `repeating-linear-gradient(
      90deg,
      ${getTagColor(percent)},    /* Line color same as progress bar */
      ${getTagColor(percent)} 0.25em, /* Line width */
      transparent 0.25em, /* Space between lines */
      transparent 0.5em
    )`,
    height: "100%",
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1, // Lines stay below the text
  };

  return (
    <div style={containerStyle}>
      <div style={linesStyle}></div>
      <div style={progressStyle}>{percent}%</div>
    </div>
  );
};

export default TaskProgress;
